module.exports = __webpack_public_path__ + "img/factura.eeed6c6a.png";